var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['dropdown-trigger__button', `dropdown-trigger__button--${_vm.size}`]},[_c('span',{staticClass:"dropdown-trigger-button__dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }